import { StripePaymentElementOptions } from '@stripe/stripe-js';
import { Links } from '../constants';
import { CheckoutOffer } from './offer';

// @stripe/stripe-js doesn't export ApplePayOption from its public entrypoint, so derive it
// from the PaymentElement options type.
type ApplePayOption = NonNullable<StripePaymentElementOptions['applePay']>;

/**
 * The apple pay recurringPaymentRequest for the membership renewal. Passing this to the
 * PaymentElement makes stripe request an apple pay merchant token (MPAN) rather than a single-use
 * device token (DPAN); the MPAN is what lets recurly charge the wallet card off-session when the
 * membership renews, so without it renewals can fail. It also makes the wallet sheet disclose the
 * renewal terms.
 *
 * Returns undefined when web reports no structured renewal terms, so apple pay falls back to a
 * standard (device token) request rather than disclosing terms we cannot verify.
 */
export function buildApplePayRecurringOption(offer: CheckoutOffer): ApplePayOption | undefined {
  const { renewalPriceInCents, renewalMonths } = offer;
  if (!renewalPriceInCents || renewalPriceInCents <= 0 || !renewalMonths || renewalMonths <= 0) {
    return undefined;
  }

  return {
    recurringPaymentRequest: {
      paymentDescription: 'Fi Membership',
      managementURL: `${window.location.origin}${Links.manageHome}`,
      regularBilling: {
        label: 'Fi Membership',
        amount: renewalPriceInCents,
        recurringPaymentIntervalUnit: 'month',
        recurringPaymentIntervalCount: renewalMonths,
      },
    },
  };
}
